import { KeyboardArrowDown, KeyboardArrowUp } from '@styled-icons/material';
import styled from 'styled-components';

import { colors } from '~/utils/css-mixins';

const LabelContainer = styled.div`
  color: ${colors.text};
  font-size: 14px;
  display: flex;
  align-items: center;

  svg {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    padding: 5px;
    background-color: ${colors.bluedark};
    fill: white;
    border-radius: 50%;
  }
`;

const Title = styled.span`
  white-space: nowrap;
`;

const Arrow = styled.span`
  svg {
    width: 25px;
    height: 25px;
    fill: ${colors.textmeta};
    background-color: transparent;
    padding: 0;
  }
`;

const HorseName = styled.span`
  font-weight: 400;
  white-space: nowrap;
`;

const ScratchedStart = styled.span`
  font-weight: 600;
  text-decoration: line-through;
`;

const ScratchedHorse = styled(HorseName)`
  text-decoration: line-through;
`;

export const getWinsText = wins => (wins === 1 ? 'seger' : 'segrar');

export const getStart = start => {
  const text = `${start.start_number} ${start.horse.name}`;

  return start.scratched ? (
    <ScratchedStart>{text}</ScratchedStart>
  ) : (
    <span>{text}</span>
  );
};

const getHorse = (scratched, text) =>
  scratched ? (
    <ScratchedHorse>{text}</ScratchedHorse>
  ) : (
    <HorseName>{text}</HorseName>
  );

export const Label = ({ scratched, expandable, Icon, title, text, open }) => (
  <LabelContainer>
    {Icon}
    <div>
      <div>
        <Title>{title}</Title>
        {expandable && (
          <Arrow>{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}</Arrow>
        )}
      </div>
      {getHorse(scratched, text)}
    </div>
  </LabelContainer>
);
